// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// creditAcreage is the current total charged credits — it already includes any edit/adjustment
// deltas tracked separately in adjustedAcres, so it must not be added again.
const getTotalChargedCredits = (order: IOrder) => order.creditAcreage || 0;

export default getTotalChargedCredits;
